import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/dist/ScrollTrigger";
import ReactHtmlParser from "react-html-parser";
import CountUp from 'react-countup';
import VisibilitySensor from "react-visibility-sensor";
import Button from "../ButtonV1";
import Title from "../Title";
import {black, darkBlue, white} from "../../styles/globalStyleVars";
import {Img} from "../Img";

const CountSection = ({padding, data,id,link}) => {
    gsap.registerPlugin(ScrollTrigger);
    const [offset, setOffset] = useState(90)

    useEffect(() => {
        // window.addEventListener('scroll', function () {
        //     ScrollTrigger.refresh();
        // })
        setOffset(document.querySelector(' .container').offsetLeft)

        window.addEventListener('load', function () {
            setOffset(document.querySelector(' .container').offsetLeft)

        })
        window.addEventListener('resize', function () {
            setOffset(document.querySelector(' .container').offsetLeft)

        })


    }, [data])



    let desc=`<p class='split-up'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
</p> <p class='split-up'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>`

    return (

        <StyledCountSection id={`${id ? id : 'counter_section'}`} className={`counter pt-200 pb-200 parallax-img`}>
            <Container>
                <Row>
                    <Col>
                        <div className="fixed_img parallax-inner">
                            <svg xmlns="http://www.w3.org/2000/svg" width="430.129" height="600" viewBox="0 0 430.129 600">
                                <defs>
                                    <clipPath id="clip-path">
                                        <rect id="Rectangle_5919" data-name="Rectangle 5919" width="430.129" height="600" fill="#fff"/>
                                    </clipPath>
                                </defs>
                                <g id="Bangladesh_Map" data-name="Bangladesh Map" opacity="0.05" clip-path="url(#clip-path)">
                                    <path id="Path_10800" data-name="Path 10800" d="M368.24,503.952c-.04-3.726-1.551-7.487.369-11.188.214-.413-.593-1.865-.667-1.846-9.879,2.592-3.658-5.066-4.886-7.821-4.127-9.263-1.944-20.392-8.812-29.007-2.2-2.762.008-6.373,2.722-10.6-5.088,2.9-7.17,2.48-7.653-1.861-2.064-18.56-11.865-32.81-25.3-45.005-3.008-2.729-5.2-5.758-2.911-10.622-3.935,5.422-11.233,6.252-14.129,12.78-1.238,2.79-4.348,2.05-6.555-.1-2.072-2.017-3.964-2.952-5.84.4-2.193,3.924,1.361,3.533,3.061,4.009,3.454.967,3.768,3,2.77,5.911-1.494,4.352-4.21,6.891-9.054,7.274-4.907.389-7.18-1.985-8.2-6.378-.224-.968-.928-1.826-1.835-3.534-1.2,2.721-1.573,5.533-4.811,5.983-3.212.446-4.975-1.44-6.51-3.445-6.912-9.028-15.882-16.817-17.611-29.029a13.1,13.1,0,0,0-3.781-7.6c-6.737-6.523-6.667-14.281-4.2-22.409,1.683-5.543,2.37-10.122-2.679-15.023-4.793-4.651-1.458-12.306,5.285-14,4.151-1.041,5.033-3.322,2.862-6.777-.628-1-2.589-1.886-2.408.424.462,5.89-5,1.929-6.556,4.247-1.786-2.3-1.588-4.714-.384-7.17.416-.848.885-1.67,1.366-2.57-3.128-1.815-4.886-.238-6.036,1.912-1.5,2.8-4.227.343-6.2,1.6,8.123,4.253,9.959,8.492,6.6,14.45-1.144,2.028-2.045,2.957-4.811,2.128-7.663-2.3-15.841-2.613-23.117-6.02-1.444,1.367-.316,2.308.387,2.585,9.483,3.739,15.122,14.527,26.775,14.43,2.536-.021,4.132,2.708,4.279,4.973a46.04,46.04,0,0,1-.578,12.255c-1.1,5.243-6.09,3.515-9.453,3.861-5.821.6-4.573,4.181-3.266,7.2,1.735,4.011,4.259,7.68,6.518,11.624-.925,2.815-5.45-.374-5.916,3.319l.269-.273c-3.03,2.661-3.023,7.315-6.7,9.71-2.449,1.6.305,2.973,1.189,2.9,9.522-.765,8.412,6.791,8.868,12.1.239,2.778.7,3.729,2.974,4.943a10.625,10.625,0,0,1,3.957,4.631c6.355,12.938,4.266,23.63-6.307,34.4-1.2,1.226-1.771,3.122-2.483,4.772-1.028,2.38-1.657,5.1-5.049,5.07-3.923-.034-2.027-3.974-4.114-6.215-2.383,8-8.283,13.987-8.52,22.462-.146,5.2-3.851,8.384-7.884,10.98-3.155,2.031-6.451.2-8.836-1.247-3.688-2.245,1.644-4.65.766-7.287-.156-.708-.476-.706-1.09-.237-2.048,1.563-3.361,6.3-6.359,3.753-2.443-2.072-1.526-6.386.4-9.4,1.734-2.714,5.448-4.323,4.535-8.48-2.4-.248-2.3,1.962-3.036,3.185-1.234,2.051-3,2.251-4.619,1.183-1.872-1.232-.583-2.97.439-3.942,3.469-3.3.928-8.348,3.8-11.8-2.139,6.193-8.774,10.084-7.885,19.023-8.091-8.428-3.983-18.27-7.573-26.154-4.373-9.6,6.1-14.881,7.757-23.112-2.521,3.931-8.975,3.295-9.493,9.779-.409,5.125-4.229,9.386-1.97,15.566,1.439,3.935,5.073,10.851-3.135,13.647,2.576,3.394.812,8.378,2.947,11.212,4.578,6.078-.161,8.209-3.6,10.623-6.47,4.537-13.611,1.459-14.811-6.024-4.626,4.335-4.635,4.421,1.013,10.552.964,1.046,3.1,1.527,1.849,3.53a2.875,2.875,0,0,1-3.5,1.047c-4.52-1.7-5.276,1.147-5.417,5.2-5.208-3.552-6.988-8.674-4.726-12.991,4.616-8.808,1.036-19.036,6.133-27.765,1.741-2.982-3.36-6.755-3.691-10.977-.9,7.25,2.3,15-2.941,21.851,1.557-9.8-5.355-18.041-4.189-27.837-3.772,5.506-3.261,11.188-.493,16.524,2.8,5.4,2.9,18.762-.666,23.872a7.036,7.036,0,0,0-1.555,5.034c.537,4.835-.97,10.784-5.641,10.017-5.661-.929-3.014-7.044-2.1-11.23,1.563-7.128,1.567-7.127-3.127-12.447,2.749,5.6-.594,9.674-3.5,13.27-3.671,4.548-1.173,9.7-2.446,14.472-.684,2.564-1.388,3.667-3.531,3.865-3.26.3-3.214-1.846-2.516-4.116,1.11-3.608-1.512-6.449-1.922-9.74a1.859,1.859,0,0,0-1.838-1.916c-6.767-.972-9.946-5.226-8.485-12.393.824-4.043,1.408-7.594-1.307-11.081a3.591,3.591,0,0,1-.738-2.913c4.27-9.645-3.681-16.889-4.768-25.364-1.731-13.49-5.311-26.461-8.9-39.479-.138-.5-.495-1.219-.29-1.488,5.631-7.431.87-12.522-3.091-18.769-5.94-9.369-4.3-15.741,3.791-23.4a62.638,62.638,0,0,1,5.682-4.093c-7.147-2.438-11.584-6.157-17.749-4.109a7.878,7.878,0,0,1-8.439-2.49c-2.25-2.581-.343-5.365,1.046-7.908.995-1.82,2.337-3.639,2.655-5.6.629-3.883,7-8.7-3.073-11.03-5.063-1.169-9.114-7.545-13.184-11.97-4.4-4.784-.493-10.454-.415-15.6.068-4.407.661-9.857,8.364-10.485,5.926-.483,8.649-12.447,4.756-18.021-3.46-4.954-3.273-9.08,1.391-13.166,4.474-3.92,3.114-12.683-2.189-15.2-.88-.417-2.338-1-2.849-.608-9.144,6.967-16.34,1.505-24.042-3.175-7.768-4.721-15.909-8.871-24.1-12.833-3.412-1.651-5.535-3.525-5.6-7.429-.022-1.26-.069-3.005-.845-3.693-9.212-8.16-1.5-14.385,2.562-20.665,1.761-2.721,4.183-4.811,2.3-8.213-1.644-2.975-.155-4.316,2.325-5.279,2.718-1.056,4.974-.612,6.885,1.864,5.582,7.23,7.071,7.358,11.978-.155,4.408-6.748,7.726-14.079,7.314-22.492-.121-2.46.2-5.994,3.083-4.816,7.285,2.981,14.775-2.3,21.967,1.484,2.984,1.572,6.993,2.96,9.709-1.326.217-.343,1.091-.69,1.335-.533,9.142,5.923,9.775-4.083,13.723-7.52,2.388-2.079,1.61-4.3-1.827-4.671-8.5-.906-14.3-3.7-12.878-14.131.66-4.845-4.21-7.181-9.128-5.194-9.951,4.022-24.455-3.462-27.11-14.3-1.515-6.184-7.818-7.312-11.093-11.542-3.59-4.639-7.14-7.918-13.773-4.286C8.182,87.19,2.845,78.39,4.519,72.785A65.855,65.855,0,0,1,9.554,61.479c.692-1.329,2.461-2.342,1.923-4.013-2.9-9,3.986-11.032,9.761-13.567,3.913-1.718,7.294-2.811,7.637-8.365.319-5.157,5.6-8.045,9.8-8.391,6.807-.561,4.716-4.167,3.543-7.305a9.513,9.513,0,0,0-6.676-5.732,12.394,12.394,0,0,0-4.956-.258c-1.436.226-3.109,1.438-3.912-.538a5.213,5.213,0,0,1-.116-2.616c.149-1.18.1-2.671,1.025-3.547A7.577,7.577,0,0,1,29.716,5.99c2.335-1.089,1.206-3.2,1.455-5.334a.768.768,0,0,1,.156-.449A.79.79,0,0,1,31.87.032a4.983,4.983,0,0,1,2.873.395,4.047,4.047,0,0,1,1.01.928c2.023,2.434,2.876,5.552,4.552,8.2,1.656,2.615,4.437,3.416,7.159,4.7,6.616,3.13,10.14,8.526,14.339,13.479,3.617,4.265-4.919,3.752-3.737,7.689,2.414,1.415,4.329-.789,6.43-1.3,2.2-.531,4.537-1.156,5.55.991,2.443,5.183,4.5,5.452,7.994.757,1.763-2.368,3.751.243,5.133,1.553,2.267,2.148,4.561,3.25,7.727,2.1,3.044-1.1,3.913-2.365.986-4.662-2.981-2.339-4.6-6.115-8.4-7.662-2.868-1.169-4.005-3.216-1.986-6.172,1.9-2.781,4.059-3.009,6.5-.777,4.289,3.927,9.843,5.732,9.444,14.285-.508,10.88,9.2,17,16.539,24.043,5.051,4.85,10.953,4.334,16.592,5.416,2.716.521,5.463-.446,7.47,2.5,1.047,1.539,2.981,1.421,3.434-.674a13.916,13.916,0,0,1,4.818-7.789c1.252-1.091,1.474-2-.188-3.649-5.07-5.033,1.4-8.738,2.172-13.151.129-.738,2.153-.639,2.508.482,2.127,6.709,10.206,9.867,10.1,18.227-.046,3.578,6.279,5.007,5.976,10.138-.079,1.333.689,2.835-.4,4.08-4.891,5.567-3.61,11.878-1.332,17.68,3.961,10.088,2.321,20,.217,29.945a29.83,29.83,0,0,0-.773,9.264c.4,3.893,1.365,7.475,6.778,5.468,3.267-1.211,6.167.434,8.959,1.726,8.273,3.831,17.21,5.925,25.541,9.268,11.371,4.564,22.434,1.181,33.565,2.057,6.171.486,12.49-.6,18.581,1.861,2.219.9,5.206.587,7.673.048,10.387-2.272,20.752-4.429,31.416-5.141,2.64-.177,4.421.987,6.579,1.587,7.824,2.176,15.274,7.446,23.9,2.829.228-.122.538-.336.719-.268,14.393,5.4,27.858-4.375,42.252-2.58,5.576.7,9.634,3.38,14.187,5.386,10.165,4.481,20.705,8.627,27.839,17.915,1.74,2.267,6.206,4.359,2.65,7.481-2.762,2.425-6.675,5.308-11.16,2.369-1.735-1.137-3.5-2.235-5.24-3.362-2.089-1.352-4.463-2.088-6.579-.668s-1.366,3.985-.637,5.771c1.44,3.53.695,6.843-.849,9.78-4.049,7.7-2.451,17.722-10,24-.7.584-.55,2.522-.378,3.775,1.049,7.657-2.23,10.51-9.8,9.693-4.342-.469-9.044,5.191-9.138,9.786a41.775,41.775,0,0,1-1.206,6.865c-.382,1.988-.182,4.6-2.707,5.081-2.494.473-3.742-1.565-4.216-3.721-.783-3.56-3.889-3.206-6.209-3.5-2.461-.314-2.64,1.872-2.488,3.837.135,1.742.891,3.912-1.507,4.6-2.68.77-3.568-1.489-4.436-3.369-.553-1.2-.914-2.465-2.538-2.528-3.927,12.733-3.933,12.774-17.674,10.91-5.266-.714-9.4-.35-9.243,6.633.041,1.872-.53,3.837-3.45,4.33-6.965,1.177-8.869,6.262-8.409,12.576.393,5.4.491,10.516-5.905,12.751a2.6,2.6,0,0,0-1.849,3.083c2.11,6.8.28,14.564,4.871,20.72,7.1,9.518,8.653,20.613,9.419,31.974a14.391,14.391,0,0,0,.75,3.815c1.235,3.47,1.218,9.512,5.918,8.41,3.4-.8.93-6.3.6-9.727-.123-1.291-.444-2.564-.549-3.856-.154-1.9.046-3.86,2.09-4.6,2.225-.81,3,1.129,4.175,2.545,4.683,5.656,5.2,12.946,7.691,19.438,2.48,6.463,5.33,9.269,12.83,6.5,10.424-3.851,14.594-10.043,12-20.692-3.428-14.08-1.722-18.416,10.825-26.271,5.426-3.4,5.7-8.4,4.593-13.7-.957-4.58-1.988-9.072-1.186-13.861,3.238-.313,3.588,2.721,5.056,4.2,3,3.03,5.352,3.317,8.425-.033,6.851-7.469,6.967-7.362,11.451,1.077,3.137-.419,1.773-4.641,5.594-5.725a46.153,46.153,0,0,0,1.882,18.589c1.738,5.385,3.151,10.876,5.3,16.141,1.891,4.623,1.078,9.245.839,14.147-.594,12.189-3.258,25.25,6.86,35.55a4.919,4.919,0,0,1,1.1,1.954c4.121,13.434,7.8,26.958,9.416,40.984.834,7.226,3.962,14.644,2.97,21.531-2.2,15.251,4.071,29.691,2.22,44.95-1.746,14.394-.871,29.122,4.147,43.165.606,1.7,1.377,3.553,1.21,5.25a5.042,5.042,0,0,1-4.614,4.589c-2.618.358-3.114-1.993-3.212-3.57-.413-6.621-4.161-8.252-10.015-7.463-2.469.333-4.9-.367-5.9-2.838-1.066-2.633-1.963-7.2-4.642-6.074-3.653,1.535-8.393,2.459-10.577,6.75-5.377,10.564-7.424,20.934,1.494,30.82.82.909,2,2.285,1.811,3.189-2.626,12.378,11.414,23.712,5.068,34.737a78.824,78.824,0,0,1-7.027-10.349c-4.97-8.425-9.307-17.205-13.639-25.976l-5.9-11.948a20.265,20.265,0,0,1-2.5-7.285c-.231-3.087.956-6.09,1.307-9.165.706-6.176-4.823-7.041-3.352-12.431,1.569-5.746,3.928-11.443,5.42-17.378,1.615-6.422-4.7,1.884-5.85-1.812Z" transform="translate(0 0.004)" fill="#fff"/>
                                    <path id="Path_10801" data-name="Path 10801" d="M629.847,1109.606c-8.056-10.187-1.528-18.711.8-27.709,1.548-5.99-.059-12.336-.531-18.406-.63-8.1-3.828-11.626-9.052-15.96-3.416-2.834-.315-14.55,3.615-16.772,2.788-1.575,3.606.08,4.556,2.132,4.911,10.606,7.658,22.389,16.677,30.774.363.338.839.865.807,1.268-.556,6.942-1.8,13.828-1.208,20.855.656,7.769-2.884,13.11-9.578,16.973-2.3,1.325-3.74,4.126-6.084,6.845" transform="translate(-384.041 -638.505)" fill="#fff"/>
                                    <path id="Path_10802" data-name="Path 10802" d="M748.684,1149.473c.114,5.1-6.573,14.392-11.328,15.557a4.371,4.371,0,0,1-2.854-.41,2.085,2.085,0,0,1-.587-3.333c5.526-5.739,4.261-12.937,4.578-19.828.078-1.693-.635-4.03,1.516-4.776,2.285-.792,4.014,1.017,5.146,2.655a18.455,18.455,0,0,1,3.529,10.134" transform="translate(-454.535 -704.428)" fill="#fff"/>
                                    <path id="Path_10803" data-name="Path 10803" d="M950.208,1308.154c-.026,3.62-.243,7.252-.036,10.859.382,6.662-6.322,3.555-8.8,6.389-.458.524-2.163-1.665-1.547-2.819,2.614-4.9.739-9.568-.235-14.351-.59-2.9-.366-2.867,4.058-6,.616-.436.489-1.95.661-2.973.132-.783.354-1.418,1.643-1.306,1.79,3.255-.192,8.417,4.526,10.5l-.268-.3" transform="translate(-582.236 -804.5)" fill="#fff"/>
                                    <path id="Path_10804" data-name="Path 10804" d="M597.314,1006.49c5.361,1.834,11.619-4.615,16.492,1.792.594.78,1.275,1.494,2.758,3.218-7.66-1-12.564,1.317-13.925,8.4-6.382-3.214-4.5-8.856-5.056-13.674,0,0-.269.27-.269.27" transform="translate(-370.232 -623.157)" fill="#fff"/>
                                    <path id="Path_10805" data-name="Path 10805" d="M838.167,1082.868c2.75,3.56,5.608,6.624,7.671,10.153,1.39,2.376,2.144,5.963-.724,7.708-2.824,1.718-5.573-.08-7.085-2.878-2.461-4.555-5.254-9.208.138-14.983" transform="translate(-517.602 -671.19)" fill="#fff"/>
                                    <path id="Path_10806" data-name="Path 10806" d="M622.191,974.612c-2.536-.885-3.869-4.332-7.328-3.135-1.279.443-3.271.642-4.016-1.128-.852-2.024.682-3.425,2-4.619,1.335-1.21,2.751-2.2,4.785-.868,2.3,1.511,4.438,5.6,4.56,9.75" transform="translate(-378.468 -597.651)" fill="#fff"/>
                                    <path id="Path_10807" data-name="Path 10807" d="M582.513,1240.15c-1.383-4.517,2.238-8.289,1.067-12.952,7.991,5.617,7.764,7.614-1.067,12.952" transform="translate(-360.859 -760.65)" fill="#fff"/>
                                    <path id="Path_10808" data-name="Path 10808" d="M605.724,1212.61c-2.9-2.965,2.259-3.961.763-6.44l-4.4,1.892c1.936-5.477,6.628-7.112,10.383-9.929-3.5,4.183-.917,11.2-6.744,14.478" transform="translate(-373.189 -742.634)" fill="#fff"/>
                                    <path id="Path_10809" data-name="Path 10809" d="M937.248,1256.962c3.839,6.237-.609,11.209-2.062,16.426,1.934-5.177-1.735-10.812,2.063-16.426" transform="translate(-579.654 -779.099)" fill="#fff"/>
                                </g>
                            </svg>
                        </div>
                    </Col>
                </Row>

                <div>
                    <Row>
                        <Col md={12}>
                            <Title text={data?.title ? data?.title :'About Us'} margin={'0 0 60px 0'} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={5} className={'counter_left pr-0'}>
                            <div className="content">
                                {
                                    data?.subtitle && <h3 className={'split-up'}>{data?.subtitle}</h3>
                                }

                            </div>
                        </Col>
                        <Col md={{span: 5, offset: 2}}>
                            <div className="content ">
                                {data?.description && ReactHtmlParser(data?.description)}
                                <Button icon src={'/about'} color={`${white}`} hoverColor={`${white}`} text={'Learn More'} margin={'40px 0px 0px 0'}/>

                            </div>
                        </Col>

                    </Row>
                </div>

            </Container>
        </StyledCountSection>

    )
};


const StyledCountSection = styled.div`
  background: ${darkBlue};
  //padding: 35px 0 160px;
  position: relative;
  padding-bottom: 350px !important;

  .text3 {
    //position: absolute;
    //top: 50%;
    //left: 50%;
    //transform: translate(-50%,-50%);
    //padding: 0;
    //overflow: hidden;
    overflow: hidden;
    span {
      display: inline-block;
    }
  }  
  .text4 {
    overflow: hidden;
    span {
      display: inline-block;
    }
  }
  .fixed_img {
    position: absolute;
    right: 20px;
    object-fit: contain;
    height: 100%;

    top: -40px;
    @media(max-width: 767px){
      height: auto;
      right: 0;
      left: 0;
      bottom: 100px;
      svg{
        height: 100%;
        width: 100%;

      }
    }
  }

  .subtitle {
    margin-bottom: 80px;

    p {
      margin: 0;
    }

    @media (max-width: 767px) {
      margin-bottom: 40px;
    }
  }

  .counter_left {
    h3{
      color: ${white};
      margin-bottom: 40px;
    }
 }

  p{
    color: ${white} !important;
    margin-bottom: 24px;
    &:last-child{
      margin-bottom: 0px;
    }
  }
  //p {
  //  color: #4F616B;
  //}

  .content_large {
    margin: 120px 0;

    &.counter{
      
    }
    h3 {
      font-size: 160px;
      line-height: 160px;
      font-weight: 500;
      color: #D80028;
      position: relative;
      padding-bottom: 20px;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      &:after {
        position: absolute;
        left: 0;
        right: 0;
        width: 100%;
        background: #D80028;
        height: 1px;
        content: "";
        bottom: 0;
      }

      p{
        font-size: 160px;
        line-height: 160px;
        font-weight: 500;
        color: #D80028;
      }
      
      @media(max-width: 1024px) and (min-width: 768px){
        font-size: 100px;
        line-height: 100px;
        p{
          font-size: 100px;
          line-height: 100px;
        }
      }
      
      @media(max-width: 767px){
        padding-bottom: 12px;
        margin-bottom: 12px;
      }
    }

    p {
      color: #D80028;
      font-size: 18px;
      line-height: 40px;
    }

    @media (max-width: 767px) {
      margin: 100px 0 40px;
      h3 {
        color: #D80028;
        font-size: 40px;
        line-height: 40px;
        p{
          color: #D80028;
          font-size: 40px;
          line-height: 40px;
        }
      }

    }
  }

  .counter_bottom {
  
    .counter {
      h4 {
        font-size: 60px;
        line-height: 60px;
        font-weight: 500;
        color: #4F616B;
        position: relative;
        padding-bottom: 12px;
        margin-bottom: 12px;

        &:after {
          position: absolute;
          left: 0;
          right: 0;
          width: 100%;
          background: #C4C4C4;
          height: 1px;
          content: "";
          bottom: 0;
        }
        
        @media(max-width: 767px){
          font-size: 40px;
          line-height: 40px;
        }
      }
      
      @media(max-width: 767px){
        p{
          font-size: 16px;
        }
      }
    }
    @media(max-width: 992px) and (min-width: 768px){
      .counter_bottom_single{
        flex: 0 0 50%;
        max-width: 50%;
        margin-bottom: 40px;

        &:last-child{
          margin-bottom: 0;
        }
      }
     
    }
    @media(max-width: 767px){
      .counter_bottom_single{
        margin-bottom: 40px;
        &:last-child{
          margin-bottom: 0;
        }
      }
    }
  }

  @media (max-width: 767px) {
    padding-bottom: 120px !important;
    //padding: 100px 0;
  }
  @media(min-width: 1500px){
    padding-bottom: 270px !important;
  }
`;


export default CountSection;
